import { all, call, put, throttle } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client';
import { searchFailure, searchSuccess, searchTags } from './actions';
function* apiSearch(query) {
    return yield call(requestPuppy, {
        method: 'get',
        url: '/tags/search',
        params: {
            query
        }
    }, ()=>({
            tags: [
                {
                    name: 'Obi-wan Kenobi'
                },
                {
                    name: 'Luke Skywalker'
                },
                {
                    name: 'Leia Organa'
                }
            ].filter(({ name })=>name.toLowerCase().includes(query.toLowerCase()))
        }));
}
function* handleSearchTags(action) {
    if (!action.payload.query || action.payload.query.length < 2) {
        return;
    }
    const response = yield apiSearch(action.payload.query);
    if (!response || response.error) {
        yield put(searchFailure());
        return;
    }
    yield put(searchSuccess(response.tags.map(({ name })=>name)));
}
export default function* tagInputSaga() {
    yield all([
        throttle(250, searchTags, handleSearchTags)
    ]);
}

//# sourceMappingURL=saga.js.map